import React, { useEffect, useState } from "react";
import { MarketTableHeaderListItems, MarketTableHeaderLists } from "../styles";
import MarketTableTopHeader from "../MarketTableTopHeader";
import MarketTableTopHeaderTitle from "../MarketTableTopHeaderTitle";
import MarketTableHeaderListsItems from "../MarketTableHeaderListsItems";
import { loadData } from "@utils/api";
import { useTranslation } from "react-i18next";

const MarketTableMasterTraders = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  useEffect(() => {
    loadData().then((res) => {
      setData(res.slice(0, 3));
    });
  }, []);
  return (
    <MarketTableHeaderLists style={{ paddingInline: 10 }}>
      <MarketTableHeaderListItems>
        <MarketTableTopHeaderTitle title={t("masterTraders")} />
        <MarketTableTopHeader
          name={t("user")}
          amount={t("7DayProfit")}
          rate={t("7DayWinRate")}
        />
        {data.map((item, index) => (
          <MarketTableHeaderListsItems
            key={index.toString()}
            item={item}
            index={index}
          />
        ))}
      </MarketTableHeaderListItems>
    </MarketTableHeaderLists>
  );
};

export default React.memo(MarketTableMasterTraders);
